"use client";

import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section data-section-id="222459" id="cart-content" className="bg-background text-foreground py-20 md:py-32 relative overflow-hidden min-h-[80vh] flex items-center">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full max-h-[800px] bg-accent/30 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-5xl">
        <div className="mb-12 text-center md:text-left flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-border pb-8">
          <div>
            <h1 className="text-4xl md:text-6xl font-normal font-default tracking-tight mb-2">
              Your Selection
            </h1>
            <p className="text-muted-foreground font-default text-sm uppercase tracking-widest">
              Review Your Wellness Protocol & Products
            </p>
          </div>
          <div className="font-default text-xs text-primary bg-secondary px-4 py-2 rounded-full border border-border inline-flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
            ENCRYPTED CHECKOUT
          </div>
        </div>

        <div className="bg-card backdrop-blur-sm border border-border rounded-lg p-4 md:p-8 lg:p-12 shadow-md relative overflow-hidden">
          {}
          <div className="absolute inset-0 shadow-[inset_0_0_40px_rgba(0,0,0,0.01)] pointer-events-none rounded-lg" />
          
          {}
          <div className="relative z-10 [&_.wc-block-cart-item__name]:font-normal [&_.wc-block-cart-item__name]:font-default [&_.wc-block-cart-item__name]:text-xl [&_.wc-block-cart-item__price]:font-default [&_.wc-block-components-totals-item__value]:font-default [&_.wc-block-components-totals-item__value]:tracking-normal [&_.wc-block-cart__submit-button]:rounded-full [&_.wc-block-cart__submit-button]:bg-primary [&_.wc-block-cart__submit-button]:text-primary-foreground [&_.wc-block-cart__submit-button]:font-default [&_.wc-block-cart__submit-button]:uppercase [&_.wc-block-cart__submit-button]:tracking-widest [&_.wc-block-cart__submit-button]:py-4">
            <WooCommerceCartBlock />
          </div>
        </div>
      </div>
    </section>;
}